(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["novaging-newsletter"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('novaging-newsletter')) {
    customElements.define('novaging-newsletter', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        const result = this.querySelector('[data-newsletter-result]');
        const returningToGift = window.location.hash.endsWith('-GiftForm');
        if (result && !returningToGift) requestAnimationFrame(() => {
          result.scrollIntoView({ block: 'center' });
          result.focus({ preventScroll: true });
        });
        const copy = this.querySelector('[data-newsletter-copy]');
        copy?.addEventListener('click', async () => {
          const status = this.querySelector('[data-newsletter-copy-status]');
          try {
            await navigator.clipboard.writeText(copy.dataset.code);
            status.textContent = copy.dataset.copied;
          } catch {
            status.textContent = copy.dataset.copyFailed;
          }
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["novaging-offers"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('novaging-offers')) {
    customElements.define('novaging-offers', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.dialog = this.querySelector('dialog');
        this.launcher = this.querySelector('[data-offers-open]');
        this.emailForm = this.querySelector('[data-gift-form]');
        this.storageKey = 'novaging-offers-v20';
        const hash = window.location.hash;
        const giftReturn = hash === `#${this.emailForm.id}`;
        const pendingReturn = this.hasPendingSubmission() && (!hash || giftReturn || hash === '#contact_form');
        const ownReturn = giftReturn || pendingReturn;
        const error = this.querySelector('[data-email-error]');
        const accepted = ownReturn && !error && Boolean(this.querySelector('[data-email-success]'));
        if (accepted || (ownReturn && error)) this.clearPendingSubmission();
        if (accepted) this.writeSession('email-accepted');
        this.unlocked = accepted || this.readSession('email-accepted');
        this.revealed = false;
        this.querySelector('[data-email-gate]').hidden = this.unlocked;
        this.querySelector('[data-scratch-stage]').hidden = !this.unlocked;
        this.emailForm.addEventListener('submit', (event) => {
          if (!this.emailForm.checkValidity()) {
            event.preventDefault();
            this.emailForm.reportValidity();
            return;
          }
          try { sessionStorage.setItem(`${this.storageKey}-pending-submit`, String(Date.now())); } catch {}
        });
        this.onOtherCustomerSubmit = (event) => {
          if (event.target !== this.emailForm && event.target.querySelector?.('input[name="form_type"][value="customer"]')) this.clearPendingSubmission();
        };
        document.addEventListener('submit', this.onOtherCustomerSubmit, true);
        this.launcher.hidden = false;
        this.launcher.addEventListener('click', () => this.open());
        this.querySelectorAll('[data-offers-close]').forEach((button) => {
          button.addEventListener('click', () => this.dialog.close());
        });
        this.dialog.addEventListener('close', () => this.writeSession('dismissed'));
        this.dialog.addEventListener('click', (event) => {
          const bounds = this.dialog.getBoundingClientRect();
          if (event.target === this.dialog && (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom)) this.dialog.close();
        });
        this.querySelectorAll('[data-copy-code]').forEach((button) => {
          button.addEventListener('click', async () => {
            if (!this.unlocked || !this.revealed) return;
            const status = this.querySelector('[data-copy-status]');
            try {
              await navigator.clipboard.writeText(button.dataset.copyCode);
              status.textContent = this.dataset.copiedLabel;
            } catch {
              status.textContent = this.dataset.copyFailedLabel;
            }
          });
        });
        if (!this.readSession('dismissed') && !this.readSession('shown')) {
          this.scheduleOpen(10000);
        }
        if (this.unlocked) this.reveal();
        if (ownReturn && (accepted || error)) {
          this.open();
          requestAnimationFrame(() => {
            const target = accepted ? this.querySelector('[data-copy-code]') : this.querySelector('[data-email-error]');
            if (target && !target.hidden) target.focus({ preventScroll: true });
          });
        }
      }
      disconnectedCallback() {
        clearTimeout(this.openTimer);
        document.removeEventListener('submit', this.onOtherCustomerSubmit, true);
      }
      hasPendingSubmission() {
        try {
          const submittedAt = Number(sessionStorage.getItem(`${this.storageKey}-pending-submit`));
          const elapsed = Date.now() - submittedAt;
          return submittedAt > 0 && elapsed >= 0 && elapsed < 15 * 60 * 1000;
        } catch { return false; }
      }
      clearPendingSubmission() {
        try { sessionStorage.removeItem(`${this.storageKey}-pending-submit`); } catch {}
      }
      readSession(key) {
        try { return sessionStorage.getItem(`${this.storageKey}-${key}`) === '1'; } catch { return Boolean(this[`memory_${key}`]); }
      }
      writeSession(key) {
        this[`memory_${key}`] = true;
        try { sessionStorage.setItem(`${this.storageKey}-${key}`, '1'); } catch {}
      }
      scheduleOpen(delay) {
        this.openTimer = setTimeout(() => {
          if (!this.isConnected || this.readSession('dismissed') || this.readSession('shown')) return;
          const visibleDialog = Array.from(document.querySelectorAll('dialog[open], [aria-modal="true"]')).some((element) => element !== this.dialog && element.getClientRects().length > 0 && getComputedStyle(element).visibility !== 'hidden');
          const busy = document.hidden || visibleDialog || document.activeElement?.closest('form');
          if (busy) { this.scheduleOpen(4000); return; }
          this.open();
        }, delay);
      }
      open() {
        if (this.dialog.open) return;
        clearTimeout(this.openTimer);
        this.writeSession('shown');
        this.dialog.showModal();
      }
      reveal() {
        if (!this.unlocked) return;
        this.revealed = true;
        this.writeSession('revealed');
        const title = this.querySelector('[data-offers-title]');
        const intro = this.querySelector('[data-offers-intro]');
        title.textContent = title.dataset.successTitle;
        intro.textContent = intro.dataset.successIntro;
        this.querySelector('[data-scratch-prize]').removeAttribute('aria-hidden');
        this.querySelector('[data-scratch-code]').textContent = 'NOVAGING10';
        this.querySelector('[data-copy-code]').dataset.copyCode = 'NOVAGING10';
        this.querySelector('[data-scratch-result]').hidden = false;
        this.querySelector('[data-scratch-status]').textContent = `${this.dataset.revealedLabel} : NOVAGING10`;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
